import React from 'react'
import {Icon} from 'zarm'
import config from '../../../../config.js'
// import config from 'config'
const MyIcon = Icon.createFromIconfont(config.iconScriptUrl)
export default function (props) {
  return <MyIcon {...props} />
}